import React, { useRef, useState } from "react";
import CircuitStudio from "./components/CircuitStudio";
import "./App.css";
export default function App() {
  const [mode, setMode] = useState("CIRCUIT"),
    [toast, setToast] = useState(null),
    timer = useRef();
  const notify = (message, error = false) => {
    clearTimeout(timer.current);
    setToast({ message, error });
    timer.current = setTimeout(() => setToast(null), error ? 12000 : 4500);
  };
  return (
    <div className="app-shell revised-app">
      <header className="app-header">
        <div className="brand">
          <span className="brand-mark">
            <svg viewBox="0 0 30 30" aria-hidden="true">
              <path
                d="M3 20h6V9h9v11h9"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
          </span>
          <strong>Timing Diagram Simulator</strong>
        </div>
        <nav className="mode-nav" aria-label="Application mode">
          {[
            ["CIRCUIT", "Circuit Studio"],
            ["SIMULATION", "Timing Diagram Simulator"],
          ].map(([value, label]) => (
            <button
              key={value}
              className={mode === value ? "active" : ""}
              aria-current={mode === value ? "page" : undefined}
              onClick={() => setMode(value)}
            >
              {label}
            </button>
          ))}
        </nav>
        <div id="workspace-header-actions" className="header-actions" />
      </header>
      <main className="app-body">
        <CircuitStudio mode={mode} onModeChange={setMode} notify={notify} />
      </main>
      <footer className="app-footer">
        <span>© 2026 Partha Bhoumik</span>
        <span className="footer-dot" aria-hidden="true">•</span>
        <span>Timing Diagram Simulator</span>
        <span className="footer-dot" aria-hidden="true">•</span>
        <span>v3.4.3</span>
        <span className="footer-dot" aria-hidden="true">•</span>
        <span>Built for educational purpose</span>
        <span className="footer-dot" aria-hidden="true">•</span>
        <a href="mailto:partha.bhoumik@bracu.ac.bd">partha.bhoumik@bracu.ac.bd</a>
      </footer>
      {toast && (
        <div
          className={`toast ${toast.error ? "error" : ""}`}
          role={toast.error ? "alert" : "status"}
        >
          <span>{toast.message}</span>
          <button
            aria-label="Dismiss notification"
            onClick={() => setToast(null)}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}
